export var getDirectionAttribute = function (isDeparture, name) {
    var attribute = {};
    var direction = isDeparture ? 'departure' : 'arrival';
    attribute["data-".concat(direction, "-").concat(name)] = true;
    return attribute;
};
